import { FC, ReactNode } from 'react'

import { Typography, TYPOGRAPHY_WEIGHT } from 'components/Typography'
import { IRFPVendorCCPayload, TRankedVendorFullData } from './types'
import { EmptyStateForNonHospitalUser } from './CreateSurvey/EmptyState/StateForNonHospitalUser'

export type SurveyResultsBodyProps = {
  isNotRespondedSelected: boolean
  shouldUseReadonlyEmptyState: boolean
  showRespondedStakeholderMergedView: boolean
  hasSurveyData: boolean
  categoriesToShow: IRFPVendorCCPayload[]
  voteRowByCategoryUuid: Map<string, TRankedVendorFullData>
  surveyWithMergedAndSortedGrades: TRankedVendorFullData[]
  onVoteForCategory: (categoryId: string) => void
  renderCategoryChart: (voteRow: TRankedVendorFullData) => ReactNode
}

export const SurveyResultsBody: FC<SurveyResultsBodyProps> = ({
  isNotRespondedSelected,
  shouldUseReadonlyEmptyState,
  showRespondedStakeholderMergedView,
  hasSurveyData,
  categoriesToShow,
  voteRowByCategoryUuid,
  surveyWithMergedAndSortedGrades,
  onVoteForCategory,
  renderCategoryChart
}) => {
  if (isNotRespondedSelected) {
    return (
      <div className="survey-results__container">
        {categoriesToShow.map((category) => (
          <div
            key={category.id}
            className="survey-results__not-responded-category"
          >
            <Typography.Label className="contract-category-label">
              Contract category
            </Typography.Label>
            <Typography.Body1 weight={TYPOGRAPHY_WEIGHT.BOLD}>
              {category.value}
            </Typography.Body1>

            <EmptyStateForNonHospitalUser
              isReadonlyState={shouldUseReadonlyEmptyState}
              openPopup={() => onVoteForCategory(category.id)}
            />
          </div>
        ))}
      </div>
    )
  }

  if (showRespondedStakeholderMergedView) {
    return (
      <div className="survey-results__container">
        {categoriesToShow.length
          ? categoriesToShow.map((category) => {
              const voteRow = voteRowByCategoryUuid.get(category.id)
              return (
                <div
                  key={category.id}
                  className="survey-results__not-responded-category"
                >
                  {voteRow ? (
                    renderCategoryChart(voteRow)
                  ) : (
                    <>
                      <Typography.Label className="contract-category-label">
                        Contract category
                      </Typography.Label>
                      <Typography.Body1 weight={TYPOGRAPHY_WEIGHT.BOLD}>
                        {category.value}
                      </Typography.Body1>
                      <EmptyStateForNonHospitalUser
                        isReadonlyState={shouldUseReadonlyEmptyState}
                        openPopup={() => onVoteForCategory(category.id)}
                      />
                    </>
                  )}
                </div>
              )
            })
          : surveyWithMergedAndSortedGrades.map((item) => (
              <div key={item.category?.uuid ?? item.category?.name}>
                {renderCategoryChart(item)}
              </div>
            ))}
      </div>
    )
  }

  if (!hasSurveyData) {
    return (
      <div className="column">
        <div className="column align-center justify-center mt-24">
          <Typography.Headline6>No responses yet.</Typography.Headline6>
          <Typography.Body1 className="grey-text">
            Please select a user to record a response on their behalf.
          </Typography.Body1>
        </div>
      </div>
    )
  }

  return (
    <div className="survey-results__container">
      {surveyWithMergedAndSortedGrades.map(renderCategoryChart)}
    </div>
  )
}
